<template>
  <BCard
    no-body
    class="border"
  >
    <BTabs
      v-model="tripTabIndex"
      nav-class="gap-1 border-bottom-3 border-bottom-secondary p-50 mb-50"
      content-class="trip_content_class pl-25"
      pills
      @changed="handleChangedTab"
    >
      <template #empty>
        <div
          v-if="loadingSearch"
          class="text-center my-auto"
          style="min-height: 50px"
        >
          <b-spinner variant="info" />
          <span class="text-info ml-50">
            Đang tìm kiếm chuyến bay...
          </span>
        </div>
        <BAlert
          v-else
          show
          variant="warning"
        >
          Vui lòng tìm kiếm chuyến bay
        </BAlert>
      </template>
      <BTab
        v-for="itinerary of resultTrip"
        :key="itinerary.id"
        title-link-class="px-75 py-50 border-warning hover-bg-light-warning"
        no-body
      >
        <template #title>
          <div class="d-flex-center fw-700 font-medium-1">
            <span>
              {{ itinerary.name }}
            </span>
            <feather-icon
              icon="XIcon"
              size="18"
              :class="`cursor-pointer ml-75 mr-0
                ${loadingSearch ? 'text-secondary' : 'text-danger'}
              `"
              @click.stop="!loadingSearch && deleteItineraryFromResultHandle(itinerary.id)"
            />
          </div>
        </template>

        <IAmOverlay
          :loading="loadingCalculatePrice"
          :spinner-variant="'info'"
        >
          <b-card
            v-for="(trip, tripIndex) of itinerary.items"
            :key="trip.tripId"
            class="mb-75 shadow border-info"
            body-class="px-50 py-25"
          >
            <div
              v-for="(segment, segmentIndex) of trip.segments"
              :key="segmentIndex"
              :class="`mb-25 ${segmentIndex ? 'ml-1' : ''}`"
            >
              <div class="fw-700">
                <b-badge
                  v-if="segmentIndex === 0"
                  variant="info"
                  class="mr-25 fw-700 mb-25"
                  pill
                >
                  {{ tripIndex + 1 }}
                </b-badge>
                <!-- {{ getSortTripBySegment(segment) }} -->
                <span class="mr-50 text-nowrap">{{ convertISODateTime(segment.departureDate, segment.departureTimezone).time }}-{{ convertISODateTime(segment.arrivalDate, segment.arrivalTimezone).time }}</span>
                <span class="mr-50 text-nowrap">{{ convertISODateTime(segment.departureDate, segment.departureTimezone).dayAndMonth }}</span>
                <span class="mr-50 text-nowrap text-danger">{{ `${segment.airline}${segment.flightNumber}` }}</span>
                <span class="mr-50 text-nowrap">{{ `${segment.departure}${segment.arrival}` }}</span>
                <span
                  v-if="segment.airCraft"
                  class="text-nowrap"
                >{{ `| ${segment.airCraft}` }}</span>
              </div>
              <div class="d-flex flex-wrap gap-1">
                <template v-if="isEmpty(segment.bookingClassAvail)">
                  <div class="mx-1 text-danger fw-700">
                    Hết chỗ
                  </div>
                </template>

                <template v-else>
                  <b-button
                    v-for="(bookingClass, classIndex) of segment.bookingClassAvail"
                    :key="classIndex"
                    variant="transparent"
                    :class="`p-50 fw-700 ${resolveColorBookingClass(bookingClass)}`"
                    :disabled="segmentIndex !== 0"
                    @click="segmentIndex === 0 && selectTripHandle(bookingClass, trip)"
                  >
                    {{ bookingClass.code }}{{ bookingClass.availability }}
                  </b-button>
                </template>
              </div>
            </div>
          </b-card>
        </IAmOverlay>
      </BTab>
    </BTabs>
  </BCard>
</template>

<script>
import {
  BButton,
  BTabs,
  BTab,
  BAlert,
  BCard,
  BSpinner,
  BBadge,
} from 'bootstrap-vue'
import { isEmpty } from 'lodash-es'
// import {
//   onBeforeUpdate,
// } from '@vue/composition-api'

import { convertISODateTime } from '@/@core/utils/filter'

import useClassBookingPro from './useClassBookingPro'

export default {
  components: {
    BTabs,
    BTab,
    BButton,
    BAlert,
    BCard,
    BSpinner,
    BBadge,
    IAmOverlay: () => import('@/components/IAmOverlay.vue'),
  },
  setup() {
    // onBeforeUpdate(() => {
    //   console.log("UPDATE'ClassBookingProTrip' ")
    // })

    const {
      tripTabIndex,
      loadingSearch,
      resultTrip,
      loadingCalculatePrice,
      selectTripHandle,
      getSortTripBySegment,
      updateTripTabIndex,
      deleteItineraryFromResultHandle,
    } = useClassBookingPro()

    // --- *** COLOR *** ---
    function resolveColorBookingClass(bookingClass) {
      if (['LL', 'DS'].includes(bookingClass.status)) return 'LL_DS_class'

      if (['J', 'D', 'C', 'I', 'O'].includes(bookingClass.code)) return 'Bus_class'

      if (['W', 'Z', 'U'].includes(bookingClass.code)) return 'Pre_class'

      return 'Eco_class'
    }

    function handleChangedTab(currentTabs, previousTabs) {
      if (previousTabs.length < currentTabs.length) {
        setTimeout(() => {
          updateTripTabIndex(currentTabs.length)
        }, 100)
      }
    }

    return {
      tripTabIndex,
      loadingSearch,
      resultTrip,
      loadingCalculatePrice,
      handleChangedTab,
      isEmpty,
      convertISODateTime,
      selectTripHandle,
      getSortTripBySegment,
      resolveColorBookingClass,
      deleteItineraryFromResultHandle,
    }
  },
}
</script>

<style lang="scss">
/*

LL,DS: Color(0xffEFAD02) - EFAD02 - Vàng cam đậm

Bus: Color(0xFFEC2029) - EC2029 Đỏ tươi hơi hồng

PrePre: Color(0xFF64AC54) - 64AC54 Xanh lá trung bình

eco: Color(0xff005A8C) - 005A8C Xanh dương đậm vừa phải

*/

.trip_content_class {
  max-height: 700px;
  overflow-y: auto,
}

.LL_DS_class {
  color: #EFAD02;
  border: 2px solid #EFAD02;
  transition: all 0.4s ease;

  &:hover, &:focus {
      background-color: #EFAD02;
      color: white;
    }
}

.Bus_class {
  color: #EC2029;
  border: 2px solid #EC2029;
  transition: all 0.4s ease;

  &:hover, &:focus {
    background-color: #EC2029;
    color: white;
  }
}

.Pre_class {
  color: #64AC54;
  border: 2px solid #64AC54;
  transition: all 0.4s ease;

  &:hover, &:focus {
    background-color: #64AC54;
    color: white;
  }
}

.Eco_class {
  color: #005A8C;
  border: 2px solid #005A8C;
  transition: all 0.4s ease;

  &:hover, &:focus {
    background-color: #005A8C;
    color: white;
  }
}

</style>
